import md5 from 'md5'
import moment from 'moment'
import jsCookie from 'js-cookie'

export function generateSessionID(userId, file, options = {}) {
  function random(length) {
    let possible = 'abcdefghijklmnopqrstuvwxyz0123456789'
    let value = ''

    for (let i = 0; i < Number(length); i++) {
      value += possible.charAt(Math.floor(Math.random() * possible.length))
    }

    return value
  }

  let lmd = moment(file.lastModifiedDate || 'invalid')
  let session = [
    moment().format('YYYYMMDD'),
    userId,
    file.size ? file.size : '0',
    md5(escape(file.name)),
    lmd.isValid() ? lmd.format('YYYYMMDDHHmmss') : '0'
  ].join('_')

  if (options.clean) {
    jsCookie.remove(session)
    return
  }

  let token = jsCookie.get(session)
  if (!token) {
    token = random(8)
    jsCookie.set(session, token, { expires: 1 })
  }

  console.log(`generate upload session id: ${session}_${token}`)
  return `${session}_${token}`
}



// WEBPACK FOOTER //
// ./src/assets/scripts/misc.js